import type { Data } from '@strapi/types';
import { useQuery } from '@tanstack/react-query';

import { getDocumentsList } from '../api/document.api';

export const useDocumentsListInit = ({
	projectId,
	statusId,
	isProjectOpen = false,
}: {
	isProjectOpen?: boolean;
	projectId?: Pick<Data.Entity<'api::project.project'>, 'documentId'>['documentId'];
	statusId?: Pick<Data.Entity<'api::project-status.project-status'>, 'documentId'>['documentId'];
}) => {
	const {
		data: projectDocuments,
		error,
		isPending,
		isLoading,
		isError,
		refetch,
	} = useQuery({
		queryKey: ['GET_PROJECT_DOCUMENTS_LIST', projectId, statusId],
		queryFn: () => getDocumentsList({ projectId, statusId }),
		enabled: isProjectOpen,
		refetchOnWindowFocus: true,
	});

	return {
		projectDocuments,
		error,
		isPending,
		isLoading,
		refetch,
		isError,
	};
};
